import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useCallback,
} from "react";
import { useNavigate } from "react-router-dom";

import Popup, { ToolbarItem } from "devextreme-react/popup";
import { FileUploader } from "devextreme-react/file-uploader";
import Slider from "devextreme-react/slider";
import Cropper from "react-easy-crop";
import { apiBaseURL } from "../../../Utils/ProjectConstants";
import useFetch from "../../../Hooks/useFetch";
import ActionNotifications from "../../../Components/ActionNotifications";
import ErrorMessage from "../../../Components/ErrorMessage";

function createImage(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = (e) => reject(e);
    image.src = url;
  });
}

async function getCroppedImg(imageSrc, croppedAreaPixels) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  if (!ctx) {
    throw new Error("Could not get canvas context");
  }

  canvas.width = croppedAreaPixels.width;
  canvas.height = croppedAreaPixels.height;

  ctx.drawImage(
    image,
    croppedAreaPixels.x,
    croppedAreaPixels.y,
    croppedAreaPixels.width,
    croppedAreaPixels.height,
    0,
    0,
    croppedAreaPixels.width,
    croppedAreaPixels.height,
  );
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error("Failed to create cropped image."));
          return;
        }
        const file = new File([blob], "profile-picture.png", {
          type: "image/jpeg",
        });
        console.log("YYYY=>", file);
        console.log("AAAA", blob);
        resolve({ file, previewUrl: URL.createObjectURL(file) });
      },
      "image/jpeg",
      0.95,
    );
  });
}

export default function EditingPicturePopup({
  visible,
  userId,
  onClose,
  onSaved,
  mutate,
  error,
}) {
  const navigate = useNavigate(),
    fetch = useFetch(navigate);

  const [selectedImage, setSelectedImage] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [isSaving, setIsSaving] = useState(false);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [imageSrc, setImageSrc] = useState("");
  const [notifyResponse, setResponse] = useState({});
  const fetchSuccessful = (response) => {
    setResponse(response);
    return (
      response?.success &&
      response?.data?.statusCode &&
      response?.success !== "Invalid Model"
    );
  };

  const onCropComplete = useCallback((_, croppedPxels) => {
    setCroppedAreaPixels(croppedPxels);
  }, []);

  const resetState = () => {
    if (imageSrc) {
      URL.revokeObjectURL(imageSrc);
    }
    setSelectedImage(null);
    setCrop({ x: 0, y: 0 });
    setZoom(1);
    setCroppedAreaPixels(null);
    setIsSaving(false);
  };
  const cancelOptions = useMemo(() => {
    return {
      stylingMode: "outlined",
      text: "cancel",
      onClick: () => {
        resetState();
        onClose();
      },
    };
  }, [onClose, imageSrc]);

  const handleSave = async () => {
    try {
      console.log("Clicked save!!!", imageSrc, croppedAreaPixels);

      if (!imageSrc || !croppedAreaPixels) {
        console.log("Errorrrrr");
        return;
      }
      setIsSaving(true);

      const picture = await getCroppedImg(imageSrc, croppedAreaPixels);

      const formdata = new FormData();

      formdata.append("UserId", String(userId));
      formdata.append("Image", picture.file);
      for (let [key, value] of formdata.entries()) {
        console.log(`${key}:`, value);
      }
      console.log(formdata);

      let response = await fetch.form(
        `${apiBaseURL}/api/user/Profile`,
        formdata,
      );

      if (fetchSuccessful(response)) {
        mutate();
      }
      console.log("response", response, response.body);
      if (!response.ok) {
        throw new Error("Failed to upload picture");
      }

      resetState();
      await onSaved();
      onClose();
    } catch (error) {
      console.log("Save failed:", error);
    } finally {
      setIsSaving(false);
    }
  };
  const renderGrid = () => {
    return (
      <Popup
        visible={visible}
        showCloseButton={true}
        resizeEnabled={true}
        title="Edit Profile Picture"
        showTitle={true}
        width="60%"
        height="60%"
      >
        <div className="image-editor-popup">
          <div className="file-uploader">
            <FileUploader
              selectButtonText="Select Image"
              uploadMode="useForm"
              labelText=""
              accept=".jpg,.jpeg,.png"
              allowedFileExtensions={[".jpg", ".jpeg", ".png"]}
              multiple={false}
              onValueChanged={(e) => {
                const file = e.value?.[0] || null;
                setSelectedImage(file);

                if (file) {
                  const previewUrl = URL.createObjectURL(file);
                  setImageSrc(previewUrl);
                } else {
                  setImageSrc("");
                }
              }}
            />
          </div>
          {imageSrc && (
            <>
              <div className="crop-container">
                <Cropper
                  image={imageSrc}
                  crop={crop}
                  zoom={zoom}
                  aspect={1}
                  cropShape="rect"
                  showGrid={true}
                  onCropChange={setCrop}
                  onCropComplete={onCropComplete}
                  onZoomChange={setZoom}
                />
              </div>
              <div className="zoom-control">
                <label className="white">Zoom</label>
                <Slider
                  min={1}
                  max={3}
                  step={0.1}
                  value={zoom}
                  onValueChanged={(e) => setZoom(e.value)}
                />
              </div>
            </>
          )}
        </div>
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          options={cancelOptions}
        />
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          options={{
            text: isSaving ? "Saving..." : "Save",
            type: "default",
            disabled: !selectedImage || isSaving,
            onClick: handleSave,
          }}
        />
      </Popup>
    );
  };
  console.log(error);
  return (
    <div>
      <ActionNotifications response={notifyResponse} />
      <div>{!error ? renderGrid() : <ErrorMessage />}</div>
    </div>
  );
}
